// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__16r7Z","col":"styles_col__28Y2L"};